import React, { useEffect, useState } from 'react'
// Component
import { DivFlex } from '../../../../components/Common/CellText'
// Style Component
import {
  LableItem,
  ModalWrapper,
  TitleModal,
} from './PopupHandleDocumentOutgoingStyled'
// Ant design
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import { Button, message, Space, Tag, Tooltip } from 'antd'
// Mobx
import { inject, observer } from 'mobx-react'
// Other
import { blue, yellowPrimary } from '../../../../color'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import SelectGroupPopup from '../../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../../components/SelectPeoplePopup/SelectPeoplePopup'
import { ACL_ACTION_TYPE, ASSIGNEE_TYPE } from '../../../../constants'
import { SelectList } from '../../../MissionCreatePage/MissionCreatePageStyled'

const PopupHandleDocumentOutgoing = props => {
  const {
    internalDocumentStore,
    loadingAnimationStore,
    selectPeopleStore,
    aclStore,
  } = props

  const {
    selectedInternalDocumentOutgoing,
    userAssignList,
    departmentAssignList,
    groupAssignList,
  } = internalDocumentStore
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
    clearSelected,
  } = selectPeopleStore

  const {
    isVisiblePopupHandleDocument,
    handleCloseHandleDocument,
    handleCancelHandleDocument,
  } = props

  const [followerList, setFollowerList] = useState([])
  // Check chọn người dành riêng cho văn bản đến, văn bản đi
  const [isSendType, setIsSendType] = useState(false)
  const [checkCurrentUserAction, setCheckCurrentUserAction] = useState(false)

  const { aclActionsByUser } = aclStore
  useEffect(() => {
    const targetCodes = new Set([
      ACL_ACTION_TYPE.them_nguoi_INCOMING,
      ACL_ACTION_TYPE.them_nguoi_OUTGOING,
    ])
    const currentAclActions = aclActionsByUser.filter(
      item => targetCodes.has(item.code) && item.status === true
    )
    if (currentAclActions.length === 2) {
      setCheckCurrentUserAction(true)
    }
  }, [aclActionsByUser])

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    if (!isVisiblePopupHandleDocument) return

    if (selectUserData[ASSIGNEE_TYPE.FOLLOWER].length === 0) {
      selectPeopleStore.setSelectUserData(
        selectPeopleStore.convertSelectDataObj(userAssignList)
      )
    }

    if (selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER].length === 0) {
      selectPeopleStore.setSelectDepartmentData(
        selectPeopleStore.convertSelectDataObj(departmentAssignList)
      )
    }

    if (selectGroupData[ASSIGNEE_TYPE.FOLLOWER].length === 0) {
      selectPeopleStore.setSelectGroupData(
        selectPeopleStore.convertSelectDataObj(groupAssignList)
      )
    }
  }, [
    selectedInternalDocumentOutgoing,
    isVisiblePopupHandleDocument,
    originDepartmentWithUserList,
  ])

  const handleSubmit = async () => {
    const new_items_assign = []
    const remove_items_assign = []
    const listAssignOrigin = [
      ...userAssignList,
      ...departmentAssignList,
      ...groupAssignList,
    ].map(el => ({
      assignee_code: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const listAssignAfter = followerList.map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    listAssignAfter.forEach(assignAfter => {
      if (
        !listAssignOrigin.some(
          assignOrigin =>
            assignOrigin.assignee_code + assignOrigin.permission ===
            assignAfter.assignee_code + assignAfter.permission
        )
      ) {
        new_items_assign.push({
          assignee_code: assignAfter.assignee_code,
          assignee_type: assignAfter.assignee_type,
          permission: assignAfter.permission,
        })
      }
    })
    listAssignOrigin.forEach(assignOrigin => {
      if (
        !listAssignAfter.some(
          assignAfter =>
            assignAfter.assignee_code + assignAfter.permission ===
            assignOrigin.assignee_code + assignOrigin.permission
        )
      ) {
        remove_items_assign.push({
          assignee_code: assignOrigin.assignee_code,
          assignee_type: assignOrigin.assignee_type,
          permission: assignOrigin.permission,
        })
      }
    })

    const dataSubmit = {
      new_items: new_items_assign,
      remove_items: remove_items_assign,
      start_date: null,
      end_date: null,
    }
    loadingAnimationStore.showSpinner(true)
    try {
      await internalDocumentStore.updateAssignees(
        selectedInternalDocumentOutgoing.code,
        dataSubmit
      )
      await internalDocumentStore.getInternalDocumentOutgoingById(
        selectedInternalDocumentOutgoing.code
      )
      handleCloseHandleDocument()
      message.success('Xử lý văn bản thành công!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  return (
    <>
    <ModalWrapper
      closable={true}
      footer={null}
      className="handle-document-modal-custom"
      title={<div style={{ fontSize: 18, fontWeight: 600, color: '#333' }}>Xử lý văn bản</div>}
      visible={isVisiblePopupHandleDocument}
      onCancel={() => {
        handleCancelHandleDocument()
        clearSelected()
      }}>
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 14, color: '#333' }}>Chọn người theo dõi:</div>
        <Space>
          <Tooltip title="Chọn người dùng">
            <Button
              icon={<UserOutlined style={{ color: blue }} />}
              style={{ borderRadius: 8 }}
              onClick={() => {
                handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.FOLLOWER)
                setIsSendType(true)
              }}
            />
          </Tooltip>
          <Tooltip title="Chọn nhóm">
            <Button
              icon={<TeamOutlined />}
              style={{ color: yellowPrimary, borderRadius: 8 }}
              onClick={() => handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)}
            />
          </Tooltip>
        </Space>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
        {followerList.map(el => (
          <Tag
            className={'tag-selected'}
            color={'blue'}
            key={el.id}
            closable
            style={{ margin: 2, borderRadius: 16, padding: '4px 10px', display: 'inline-flex', alignItems: 'center' }}
            onClose={async () => {
              await selectPeopleStore.setCheckDocument(true)
              await selectPeopleStore.setCheckCurrentAction(
                checkCurrentUserAction
              )
              selectPeopleStore.handleRemoveSelect(el)
            }}>
            <AvatarHasName
              imgId={el.image_id}
              size={22}
              name={el.full_name}
              icon={
                (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                  <BankOutlined />
                )) ||
                (el.assignee_type === ASSIGNEE_TYPE.GROUP && <TeamOutlined />)
              }
            />
          </Tag>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 32, gap: 16 }}>
        <Button
          danger
          style={{ borderRadius: 8, minWidth: 120, height: 40 }}
          onClick={() => {
            handleCancelHandleDocument()
            clearSelected()
          }}>
          Hủy bỏ
        </Button>
        <Button
          type={'primary'}
          style={{ borderRadius: 8, minWidth: 120, height: 40 }}
          onClick={handleSubmit}>
          Đồng ý
        </Button>
      </div>

      <SelectPeoplePopup
        handleCancelSelectUser={handleCancelSelectUserDepartment}
        handleSubmitSelectUser={() =>
          setIsVisibleSelectUserDepartmentPopup(false)
        }
        isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        isSendType={isSendType}
        setIsSendType={setIsSendType}
      />
      <SelectGroupPopup
        isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
        handleCancelSelectGroup={handleCancelSelectGroup}
        handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
      />
    </ModalWrapper>
    <style>{`
      .handle-document-modal-custom .ant-modal-content {
        border-radius: 16px;
        overflow: hidden;
        background-color: #eaf1fb;
      }
      .handle-document-modal-custom .ant-modal-header {
        background-color: #eaf1fb;
        border-bottom: none;
      }
      .handle-document-modal-custom .ant-modal-body {
        background-color: #ffffff;
        margin: 0 16px 16px 16px;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
      }
      .handle-document-modal-custom .ant-select-selector {
        height: 40px !important;
        align-items: center;
        border-radius: 8px !important;
      }
      .handle-document-modal-custom .ant-tag {
        display: inline-flex;
        align-items: center;
      }
      .handle-document-modal-custom .ant-tag-close-icon {
        margin-left: 4px;
      }
    `}</style>
    </>
  )
}

PopupHandleDocumentOutgoing.propTypes = {}

export default inject(
  'internalDocumentStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'aclStore'
)(observer(PopupHandleDocumentOutgoing))
